import { message } from "antd";

export default function messages(value, status, duration) {
  if (status === "success") {
    return message.success(value, duration);
  } else if (status === "warning") {
    return message.warning(value, duration);
  } else {
    return message.error(value, duration);
  }
}
